'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Link } from '#pplx/frontend/aether/components/Link/index.js';
import { TextPrimitive } from '#pplx/frontend/aether/primitives/TextPrimitive/index.js';
import { talkToSalesCtaSelectedEvent } from '#pplx/frontend/apps/ask/talk-to-sales/analytics.js';
import { useTalkToSalesCta } from '#pplx/frontend/apps/ask/talk-to-sales/useTalkToSalesCta.js';
import { $icon } from '#pplx/frontend/icons/icon-sprite.js';
import React from 'react';
import { FormattedMessage, defineMessages } from 'react-intl';
const EMPTY_STATE_MESSAGES = defineMessages({
    orgGroupsEmptyState: {
        defaultMessage: 'User groups are available to organizations on sales-assisted plans.',
        description: 'Empty state on the gated Groups tab for self-serve orgs',
        id: '7599d8e7d1',
    },
});
/**
 * Centered empty-state talk-to-sales upsell for gated areas that have no
 * content of their own (e.g. the Groups tab on orgs without the
 * custom-groups entitlement): the gating explanation with a live
 * contact-sales link, instead of a disabled action whose explanation hides
 * behind a pointer-only popover. Self-gates on eligibility and renders
 * nothing when ineligible.
 */
export const TalkToSalesEmptyState = ({ surface, }) => {
    const cta = useTalkToSalesCta(surface);
    if (!cta) {
        return null;
    }
    return (_jsxs("div", { className: "flex w-full flex-col items-center gap-4 py-12", children: [_jsx(TextPrimitive, { color: "light", textAlign: "center", textWrap: "balance", className: "max-w-sm", children: _jsx(FormattedMessage, { ...EMPTY_STATE_MESSAGES[surface] }) }), _jsx(Link, { size: "small", variant: "secondary", href: cta.href, target: "_blank", rel: "noopener noreferrer", trailingAccessory: $icon('arrow-up-right'), track: talkToSalesCtaSelectedEvent({
                    name: 'enterprise talk to sales cta selected',
                    data: { surface, audience: cta.audience, destination: cta.destination },
                }), children: _jsx(FormattedMessage, { defaultMessage: "Contact sales", description: "Button in a gated-feature empty state that opens the sales contact flow", id: "16ed6a7d85" }) })] }));
};
//# sourceMappingURL=TalkToSalesEmptyState.js.map